import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { ProfileService } from 'src/app/services/profile/profile.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.page.html',
  styleUrls: ['./callback.page.scss'],
})
export class CallbackPage implements OnInit {

  constructor(
    private auth: AuthService,
    private router: Router,
    private spinnerService: SpinnerService,
    private profileService: ProfileService
  ) { }

  async ngOnInit() {
    const targetRoute = await this.auth.handleAuthCallback();
    
    try {
      await this.spinnerService.show();

      const token = await this.auth.getToken();
      const profile = await this.profileService.me(token);

      if (profile) { // TIP necessary if user from web browser switch from signup to login or from login to signup buttons because changes Auth0 appState retrieved from this.auth.handleAuthCallback();
        this.router.navigate(['/profile'], { replaceUrl: true });
      } else {
        this.router.navigate(['/onboarding/tutorial'], { replaceUrl: true, queryParams: { slide: 1 } });
      }
      
      await this.spinnerService.dismiss();
    } catch(err) {
      console.log(err);
      await this.spinnerService.dismissWithAlertError(err);
    }
  }

}
